import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import img from "../../assets/computer.png";
import video from "../../assets/5262343_Above_Aerial_Area_1920x1080.mp4";
import { message } from "antd";
import { useLocation } from "react-router-dom";
import { useMyContext } from "../../context/MyContext";
import axios from "axios";
import { API_BASE_URL } from "../../config/api";


const Signup = () => {
  const { signup } = useMyContext();
  const loc = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [useremail, setUserEmail] = useState("");
  const [Name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  // Hardcoded admin email as per requirements to avoid Firebase permission issues for unauthenticated users
  const [superAdminEmails] = useState(['g.mundhe@oneunionsolutions.com']);

  const handleSignup = async () => {

    if (loading) return;

    // Validate form fields
    if (!useremail || !Name || !company || !jobTitle) {
      message.error("Please fill all fields");
      return;
    }

    // Validate super admin emails
    if (superAdminEmails.length === 0) {
      message.error("No super admin emails found");
      return;
    }

    setLoading(true);

    try {
      // Send form data to the backend server, including super admin emails
      const res = await axios.post(`${API_BASE_URL}/signup/sendMail`, {
        useremail,
        Name,
        company,
        jobTitle,
        superAdminEmails,
      }, {
        // Add timeout to prevent hanging requests
        timeout: 10000
      });

      if (res.data.success) {
        message.success("Signup details sent successfully");

        // Reset form fields
        setUserEmail("");
        setName("");
        setCompany("");
        setJobTitle("");

        // Redirect to login page
        navigate("/");
      } else {
        message.error("Failed to sign up");
      }
    } catch (error) {
      console.error("Signup error: ", error);

      // Specific error handling
      if (error.response) {
        // The request was made and the server responded with a status code
        message.error(error.response.data.message || "Failed to sign up");
      } else if (error.request) {
        // The request was made but no response was received
        message.error("No response from server. Please try again.");
      } else {
        // Something happened in setting up the request
        message.error("Error in signup process");
      }
    } finally {
      // Ensure loading is set to false in all scenarios
      setLoading(false);
    }
  };

  return (
    <div className="w-full flex min-h-screen">
      <div className="lg:w-1/2 w-full lg:flex hidden justify-center items-center min-h-screen relative">
        <video
          autoPlay
          loop
          muted
          className="absolute inset-0 w-full h-full object-cover z-10"
        >
          <source src={video} />
        </video>
      </div>
      <div className="lg:w-1/2 md:px-12 px-5 w-full bg-white flex flex-col justify-center items-center gap-4 min-h-screen">
        <div className="space-y-2">
          <h2 className="md:text-3xl text-2xl text-center font-bold text-[#3C404B]">
            Signup to your account
          </h2>
          <h2 className="text-base font-normal text-center text-[#3C404B]">
            Enter your email address, name, company, and job title to continue.
          </h2>
        </div>
        <div className="py-3 px-3 shadow-md flex flex-wrap justify-between gap-2 w-4/5 rounded-xl">
          <Link
            to="/"
            className={`${loc.pathname === "/" ? "btnBg text-white" : ""
              } text-sm text-black rounded-md text-center py-3 block md:w-[45%]  btnHover hover:text-white `}
          >
            Log in
          </Link>
          <Link
            to="/signup"
            className={`${loc.pathname === "/signup" ? "btnBg text-white" : ""
              } text-sm text-black rounded-md text-center py-3 block md:w-[45%]  btnHover hover:text-white `}
          >
            Register
          </Link>
        </div>
        <div className="w-full space-y-3">
          <div className="flex flex-col gap-1 py-2">
            <label
              className="w-full text-base font-normal text-[#3C404B]"
              htmlFor="useremail"
            >
              E-Mail Address
            </label>
            <input
              onChange={(e) => setUserEmail(e.target.value)}
              value={useremail}
              type="text"
              className="w-full py-3 px-6 text-base rounded-md border-[#00000026] border outline-none active:border-cus-blue focus:border-cus-blue"
              id="useremail"
              placeholder="Enter your email"
            />
          </div>
          <div className="flex flex-col gap-1 py-2">
            <label
              className="w-full text-base font-normal text-[#3C404B]"
              htmlFor="Name"
            >
              Name
            </label>
            <input
              onChange={(e) => setName(e.target.value)}
              value={Name}
              type="Name"
              className="w-full py-3 px-6 text-base rounded-md border-[#00000026] border outline-none active:border-cus-blue focus:border-cus-blue"
              id="Name"
              placeholder="Enter your Name"
            />
          </div>
          <div className="flex flex-col lg:flex-row gap-1 py-2 justify-between">
            <div className="flex flex-col lg:w-[48%]">
              <label
                className="w-full text-base font-normal text-[#3C404B]"
                htmlFor="company"
              >
                Company
              </label>
              <input
                onChange={(e) => setCompany(e.target.value)}
                value={company}
                type="text"
                className="w-full py-3 px-6 text-base rounded-md border-[#00000026] border outline-none active:border-cus-blue focus:border-cus-blue"
                id="company"
                placeholder="Enter your company"
              />
            </div>
            <div className="flex flex-col lg:w-[48%]">
              <label
                className="w-full text-base font-normal text-[#3C404B]"
                htmlFor="jobTitle"
              >
                Job Title
              </label>
              <input
                onChange={(e) => setJobTitle(e.target.value)}
                value={jobTitle}
                type="text"
                className="w-full py-3 px-6 text-base rounded-md border-[#00000026] border outline-none active:border-cus-blue focus:border-cus-blue"
                id="jobTitle"
                placeholder="Enter your job title"
              />
            </div>
          </div>
        </div>
        <button
          onClick={handleSignup}
          className="w-full text-sm text-white rounded-md py-3 btnBg relative"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              <svg
                className="animate-spin h-5 w-5 mr-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Registering...
            </div>
          ) : (
            "Register"
          )}
        </button>
      </div>
    </div>
  );
};

export default Signup;